exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".app-logo {\n  width: 135px;\n  height: 30px;\n  -webkit-mask-image: url(" + require("../../assets/logo.svg") + ");\n  mask-image: url(" + require("../../assets/logo.svg") + ");\n  -webkit-mask-repeat: no-repeat;\n  mask-repeat: no-repeat;\n  -webkit-mask-position: bottom;\n  mask-position: bottom;\n  background-repeat: no-repeat;\n  background-size: contain;\n  background-color: #ffffff; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/components/app_logo/app_logo.scss
// module id = ./node_modules/css-loader/index.js!./node_modules/sass-loader/lib/loader.js!./src/components/app_logo/app_logo.scss
// module chunks = index